import React from "react";
import {  Button, Card, Col, Form, Row } from "react-bootstrap";
import { CCEnrollment } from "../../Physician/Models/CCEnrollment";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import CcAssessmentPathwayEnrollment from "../Models/CcAssessmentPathwayEnrollment";

import ArticleRequirementPreview from "./ArticleRequirementPreview";
import ExamRequirementPreview from "./ExamRequirementPreview";
import AnnualFeePreview from "./AnnualFeePreview";

interface IProps {
    isSectionOpen: boolean;
    onSave?: () => void;
    onUpdate?: () => void;
    onOpen?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    onContinue: () => void;
    onPrevious: () => void; 
    currentEnrollment: CCEnrollment;
    pathwayEnrollment: CcAssessmentPathwayEnrollment;
}

export default function ReviewRequirements(props: IProps){

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateSelection()) {
            props.onContinue();
        }
    }

    const onPrevious = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        props.onPrevious();
    }

    const validateSelection = () => {
        return true;
    }
    
    if (props.isLoading) return <AbpnSpinner></AbpnSpinner>
    return (
        <React.Fragment>
            { !(props.disabled) &&
                    <Card className="mb-3" border="pp-secondary-grey">
                        <Card.Body>
                            <Card.Title className="font-weight-bolder">
                            REQUIREMENTS
                            </Card.Title>
                            <Row className="mt-3">
                                    <Col xs={12} md={12} lg={12} xl={12}>
                                        <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                            <Form.Group>
                                                <p className="font-weight-bold">Please review your CC Requirements</p>
                                            </Form.Group>
                                                    {props.isLoading ? <AbpnSpinner /> : 
                                                        <React.Fragment>
                                                                <Form.Group>
                                                                    <ArticleRequirementPreview pathwayEnrollment={props.pathwayEnrollment} />
                                                                </Form.Group>
                                                                <Form.Group>
                                                                    <ExamRequirementPreview pathwayEnrollment={props.pathwayEnrollment} />
                                                                </Form.Group>
                                                            <Form.Group>
                                                            <Form.Group>
                                                                <AnnualFeePreview pathwayEnrollment={props.pathwayEnrollment} />
                                                            </Form.Group>
                                                            </Form.Group>
                                                            <Row>
                                                            <Col xs={12} lg={6}>
                                                                <Button type="button" variant="outline-pp-primary" onClick={onPrevious}>Previous</Button>
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                <Button type="submit" variant="pp-primary">Continue</Button>
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>

                                                        }
                                        </Form>
                                    </Col>
                                </Row>
                        </Card.Body>
                    </Card>        
            }
        </React.Fragment>
    )
}